<script>
import CalendarChart from "@/pages/private/charts/Calendar-chart";

export default {
  extends: CalendarChart,
  props: {
    value: Date
  },
  created() {
    this.$on("configureDay", this.configureDay);
    this.$on("selectDay", this.selectDay);
  },
  computed: {
    hasValue() {
      return this.value && typeof this.value.getTime === "function";
    },
    valueTime() {
      return this.hasValue ? this.value.getTime() : null;
    }
  },
  methods: {
    configureDay(day) {
      day.isSelected = day.date.getTime() === this.valueTime;
      // DESELECT THE DAY IF NO PRICE
      // if (day.isSelected && !day.price) { day.isSelected = false }
      if (day.isSelected) {
        day.isSelected = false;
      }
    },
    selectDay(day) {
      this.$emit("input", day.isSelected?null:day.date);
    }
  }
};
</script>

<style>
</style>